import { motion } from "framer-motion";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";

const txtVariant = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.5,
    },
  },
};



export default function Contact({ handleConversion }) {
  return (
    <section className="main-section" id="contact">
      <div className="contact-heading subheading-one-line">
        <div className="overlay-div top-border">
          <motion.h1
            className="three"
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            GET IN TOUCH
          </motion.h1>
        </div>
      </div>
      <section className="contact-details">
        <div className="overlay-div">
          <motion.div
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            Visit us <span style={{ fontSize: '1.2rem' }}>(LOCATION ON MAP)</span>
          </motion.div>
        </div>
        <div className="address">
          <a
            href="https://maps.app.goo.gl/8NUhecYQfK3b8UJx6"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'start', gap: '1rem' }}
          >
            <FaMapMarkerAlt style={{ marginTop: '0.4rem', flexShrink: 0 }} />
            Street No. 23, Ground Floor, D-23/421, 100 Feet Rd, Chhatarpur Hills, Chhatarpur, New Delhi, Delhi 110074
          </a>
        </div>
        <div className="overlay-div">
          <motion.div
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            Call us
          </motion.div>
        </div>
        <div className="phone-container">
          <a href="tel:+919716043891" className="phone-btn" onClick={handleConversion}>
            <FaPhoneAlt /> +91 9716043891
          </a>
          <a href="tel:+919899371562" className="phone-btn" onClick={handleConversion}>
            <FaPhoneAlt /> +91 9899371562
          </a>
          <a href="tel:+919999687397" className="phone-btn" onClick={handleConversion}>
            <FaPhoneAlt /> +91 9318366453
          </a>
          <a href="tel:+919999687393" className="phone-btn" onClick={handleConversion}>
            <FaPhoneAlt /> +91 9999687393
          </a>
        </div>
      </section>
    </section>
  );
}
